import { RouteObject } from "react-router";
import RootLayout from "@src/layout/Root";

import Home from "./pages/Main/Home";
import About from "./pages/Main/About";

const routes: RouteObject[] = [
  {
    path: "*",
    element: <RootLayout />,
    children: [
      {
        path: "",
        element: <Home />
      },
      {
        path: "about",
        element: <About />
      }
    ]
  }
];

export default routes;
